import { yupResolver } from '@hookform/resolvers/yup';
import { Button, FormControlLabel, Radio } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';

import FormRadioGroup from 'app/shared-components/formComponents/FormRadioGroup';
import { useStore } from 'zustand';
import { kurvFormSlice } from 'app/store/kurvFormSlice';
import { IKurvBusinessComplianceFormValues, kurvBusinessComplianceSchema } from './validation';

interface IProps {
  index: number;
  setNextForm: () => void;
  setPrevForm: () => void;
}

const KurvBusinessComplianceForm = ({ setNextForm, setPrevForm, index }: IProps) => {
  const store = useStore(kurvFormSlice);

  const methods = useForm<IKurvBusinessComplianceFormValues>({
    mode: 'onChange',
    values: store.businessCompliance,
    resolver: yupResolver(kurvBusinessComplianceSchema),
  });
  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = methods;

  return (
    <FormProvider {...methods}>
      <form
        className="flex flex-col flex-1 justify-between mt-16"
        onSubmit={handleSubmit((d) => {
          store.setBusinessCompliance(d);
          setNextForm();
        })}
      >
        <div>
          <FormRadioGroup
            id="ccTermination"
            control={control}
            tooltip="Has the business or owner ever been terminated by VS/MC/DS/or AM?"
            label="Has your account been terminated before?"
            labelClassName="mt-20"
            defaultValue={false}
          >
            <FormControlLabel control={<Radio />} label="Yes" value />
            <FormControlLabel control={<Radio />} label="No" value={false} />
          </FormRadioGroup>
          <FormRadioGroup
            id="ccThirdParty"
            control={control}
            tooltip="Are there 3rd parties/payment applications involved?"
            label="Are you involved with any 3rd parties/payment application?"
            labelClassName="mt-20"
            defaultValue={false}
          >
            <FormControlLabel control={<Radio />} label="Yes" value />
            <FormControlLabel control={<Radio />} label="No" value={false} />
          </FormRadioGroup>
          <FormRadioGroup
            id="ccPciCompliant"
            control={control}
            tooltip="Is the business PCI compliant?"
            label="Is your business PCI compliant?"
            labelClassName="mt-20"
            defaultValue={false}
          >
            <FormControlLabel control={<Radio />} label="Yes" value />
            <FormControlLabel control={<Radio />} label="No" value={false} />
          </FormRadioGroup>
          <FormRadioGroup
            id="ccInvestigations"
            control={control}
            tooltip="Has the business had any ongoing or prior data compromise investigations?"
            label="Has the business had any ongoing or prior data compromise investigations?"
            labelClassName="mt-20"
            defaultValue={false}
          >
            <FormControlLabel control={<Radio />} label="Yes" value />
            <FormControlLabel control={<Radio />} label="No" value={false} />
          </FormRadioGroup>
          <FormRadioGroup
            id="ccVisaRiskPrograms"
            control={control}
            label="Has the business been previously identified with Visa Risk Programs?"
            labelClassName="mt-20"
            defaultValue={false}
          >
            <FormControlLabel control={<Radio />} label="Yes" value />
            <FormControlLabel control={<Radio />} label="No" value={false} />
          </FormRadioGroup>
        </div>

        <div className="flex justify-end gap-[10px]">
          <Button
            variant="text"
            color="secondary"
            className="mt-16 text-[#111827] disabled:text-dark-primary disabled:text-opacity-60"
            aria-label="Back"
            type="button"
            onClick={setPrevForm}
            size="large"
          >
            Back
          </Button>
          <Button
            variant="contained"
            color="secondary"
            className="mt-16 text-white bg-blue-primary disabled:text-dark-primary disabled:bg-gray-400 disabled:text-opacity-60"
            aria-label="Next step"
            type="submit"
            size="large"
            disabled={!isValid}
          >
            Next step
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};

export default KurvBusinessComplianceForm;
